import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
/*
 *  Video Banner
 *    Animates video banner elements on mouse move.
 *
 *  Version:
 *    1.0.0 - 2021/08/27
 */

import * as ResponsiveSizes from './../../settings/Responsive';
var SELECTOR_CONTAINER = '[data-video-banner]';
var SELECTOR_MEDIA_CONTAINER = '[data-media-container]';
var SELECTOR_MEDIA = '[data-media]';
var SELECTOR_PLAY = '[data-play-icon]';
var SELECTOR_MARK = '[data-camera-mark]';

//How much the mark SVG moves based on mouse movement, bigger number = more movement
var MARK_MOVE_FACTOR = 5;
//Timeout between mousemove events
var TIMEOUT_MS = 15;
document.querySelectorAll(SELECTOR_CONTAINER).forEach(function (section) {
  var mediaContainer = section.querySelector(SELECTOR_MEDIA_CONTAINER);
  var media = mediaContainer.querySelector(SELECTOR_MEDIA);
  var play = section.querySelector(SELECTOR_PLAY);
  var mark = section.querySelector(SELECTOR_MARK);
  if (!mediaContainer || !play || !mark || !media) return;
  var timeout = false;
  var mediaWidth, mediaHeight, playWidth;
  calculateElementSizes();
  window.addEventListener('resize', function () {
    return calculateElementSizes();
  });
  mediaContainer.addEventListener('mouseover', function () {
    return onMouseOver();
  });
  mediaContainer.addEventListener('mouseleave', function () {
    return onMouseLeave();
  });
  var onMouseOver = function onMouseOver() {
    mediaContainer.addEventListener('mousemove', function (e) {
      return onMouseMove(e);
    });
  };
  var onMouseLeave = function onMouseLeave() {
    mediaContainer.removeEventListener('mousemove', function (e) {
      return onMouseMove(e);
    });
  };
  var onMouseMove = function onMouseMove(e) {
    if (window.innerWidth < ResponsiveSizes.medium) return;
    if (timeout) return;
    timeout = true;
    calculateElementSizes();
    var rect = mediaContainer.getBoundingClientRect();
    var x = e.clientX - rect.left; // X position over media
    var y = e.clientY - rect.top; // Y position over media

    var percentX = x / mediaWidth;
    var percentY = y / mediaHeight;

    //When these values === 0 the cursor is in the centre of the media
    var percentMiddleX = 1 - x / (mediaWidth / 2);
    var percentMiddleY = 1 - y / (mediaHeight / 2);

    //Update play element position
    play.style.left = "".concat(percentX * 100, "%");
    play.style.top = "".concat(percentY * 100, "%");

    //Update camera mark position
    var mm = MARK_MOVE_FACTOR;
    mark.style.left = "".concat(50 + percentMiddleX * mm, "%");
    mark.style.top = "".concat(50 + percentMiddleY * mm, "%");
    media.style.left = "".concat(50 + percentMiddleX * (mm / 2), "%");
    media.style.top = "".concat(50 + percentMiddleY * (mm / 2), "%");

    //Timeout used to debounce the event
    setTimeout(function () {
      return timeout = false;
    }, TIMEOUT_MS);
  };
  function calculateElementSizes() {
    mediaWidth = mediaContainer.offsetWidth;
    mediaHeight = mediaContainer.offsetHeight;
    playWidth = play.offsetWidth;
  }
});